import {
  SET_STEP_INDEX
} from './types'

export const state = {
  index: 0,
  entries: [
    'StepHistory',
    'StepTitle',
    'StepTags',
    'StepArticles',
    'StepRecipients',
    'StepSummary',
    'StepSuccess'
  ]
}

export const mutations = {
  [SET_STEP_INDEX] (state, value) {
    state.index = value
  }
}

export const actions = {
  setIndex ({ commit }, value) {
    commit(SET_STEP_INDEX, value)
  },
  prev ({ commit, state }) {
    const index = state.index -1
    commit(SET_STEP_INDEX, index)
  },
  next ({ commit, state }) {
    const index = state.index + 1
    commit(SET_STEP_INDEX, index)
  },
  reset ({ commit }) {
    commit(SET_STEP_INDEX, 0)
  }
}

export const getters = {
  current (state) {
    return state.entries[state.index]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mailings/step.js